import { render, staticRenderFns } from "./InstagramInstantwinAnalyticsPublic.vue?vue&type=template&id=019bc154&scoped=true"
import script from "./InstagramInstantwinAnalyticsPublic.vue?vue&type=script&lang=ts"
export * from "./InstagramInstantwinAnalyticsPublic.vue?vue&type=script&lang=ts"
import style0 from "./InstagramInstantwinAnalyticsPublic.vue?vue&type=style&index=0&id=019bc154&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019bc154",
  null
  
)

export default component.exports